import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamMetricsAppViewsSummaryTotalIndividualAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/summary/team-metrics-app-views-summary-total-individual.aggregate-root.mapper';
import { GetTeamMetricsAppViewsSummaryTotalIndividualRequestDto } from '../../../dtos/team-metrics/summary/get-team-metrics-app-views-summary-total-individual.request.dto';
import { GetTeamMetricsAppViewsSummaryResponseDto } from '../../../dtos/team-metrics/summary/get-team-metrics-app-views-summary.response.dto';
import { GetTeamMetricsAppViewsSummaryTotalIndividualQuery } from '../../../queries/team-metrics/summary/get-team-metrics-app-views-summary-total-individual.query';

export class GetTeamMetricsAppViewsSummaryTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsAppViewsSummaryTotalIndividualQuery,
    protected readonly mapper: TeamMetricsAppViewsSummaryTotalIndividualAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsAppViewsSummaryTotalIndividualRequestDto
  ): Promise<GetTeamMetricsAppViewsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetTeamMetricsAppViewsSummaryTotalIndividualController.get encountered an error: ${error}`
      );
    }
  }
}
